import { useContext } from 'react';

import { StructuredDataContext } from '../providers/StructuredDataProvider';

const useStructuredData = () => useContext(StructuredDataContext);

export default useStructuredData;
